<!-- =========================================================================================
    File Name: EmailView.vue
    Description: Email Application - Single Email View (Inbox)
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vs-sidebar click-not-close parent="#email-app" :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" v-model="isSidebarActive" position-right>
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentNotice">
        <div class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer mr-4" svg-classes="w-6 h-6"></feather-icon>
              <h4 v-if="currentNotice.title">{{ currentNotice.title }}</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div class="email__actions--single flex items-baseline">
              <feather-icon icon="EditIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeUserLevel >= 3 && activeSpaceInfo.service == true" @click="editNotice()"></feather-icon>
              <feather-icon icon="TrashIcon" svg-classes="h-6 w-6" class="cursor-pointer ml-4" v-if="activeUserLevel >= 3 && activeSpaceInfo.service == true" @click="deleteNotice()"></feather-icon>
              <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('previousMail')" />
              <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'" svg-classes="h-6 w-6" class="cursor-pointer ml-4 hidden sm:inline-flex" @click="$emit('nextMail')" />
            </div>
          </div>
        </div>
        <component :is="scrollbarTag" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6" :settings="settings" :key="$vs.rtl">
          <div v-if="isSidebarActive">
            <!-- LATEST MESSAGE -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <vx-card class="px-4" >
                  <!-- MAIL HEAD -->
                  <div class="vx-row">
                    <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
                      <!-- Sender Details -->
                      <div class="flex items-center">
                        <div class="flex flex-col">
                          <h5 class="mb-1">{{ currentNotice.name }}</h5>
                        </div>
                      </div>
                      <!-- /Sender Details -->
                      <!-- Mail Time & Date -->
                      <div class="flex flex-col justify-end">
                        <span class="text-right">{{ currentNotice.update_time | time }}</span>
                        <div class="flex justify-end mt-2">
                          <span class="text-right">{{ currentNotice.update_time | date(true) }}</span>
                        </div>
                      </div>
                    </div>
                    <!-- /Mail Time & Date -->
                  </div>
                  <!-- MAIL CONTENT -->
                  <div class="vx-row">
                    <div class="output ql-snow">
                      <div class="ql-editor" v-html="currentNotice.detail"></div>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
            <div class="vx-row" style="margin-top: 2.2rem">
              <div class="vx-col w-full"  v-for="(item, index) in fileList" v-bind:key="index" style="margin-bottom:10px;">
                <vx-card>
                  <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                      <span class="text-lg">{{item}} </span>
                      <feather-icon v-if="activeUserLevel >= 2" svg-classes="h-6 w-6" class="cursor-pointer ml-4" icon="DownloadIcon" @click="fileDonwload(item)"></feather-icon>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </component>
      </div>
    </vs-sidebar>
    <vs-prompt
      class="email-compose"
      title="공지사항 수정"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="updateNotice"
      :active.sync="activePrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <div class="mt-4" v-if="shareClass.length > 0">
            <!-- <label class="text-sm">수업 동기화</label> -->
            <v-select v-model="languages_known"  placeholder="동기화 수업 없음" multiple :closeOnSelect="false" :options="shareClass" v-validate="'required'" name="lang_known" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            <!-- <span class="text-danger text-sm"  v-show="errors.has('lang_known')">{{ errors.first('lang_known') }}</span> -->
          </div>
          <vs-input name="title" label-placeholder="제목" v-model="title" class="w-full mb-6" />
          <quill-editor v-model="message" :options="editorOption" style="height:220px;">
            <div id="toolbar" slot="toolbar">
              <button class="ql-bold">Bold</button>
              <button class="ql-italic">Italic</button>
              <select class="ql-size">
                <option value="small"></option>
                <option selected></option>
                <option value="large"></option>
                <option value="huge"></option>
              </select>
              <select class="ql-font">
                <option selected="selected"></option>
                <option value="serif"></option>
                <option value="monospace"></option>
              </select>
              <button class="ql-video"></button>
            </div>
          </quill-editor>
          <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
            <div class="w-full" v-for="(item, index) in newFileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
              <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                <div class="vx-card__collapsible-content" style="text-align:center;">
                  <div class="vx-row" style="margin:5px; ">
                    <div  style="width: 90%;">
                      <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">
                        {{item.name}}
                      </div>
                    </div>
                    <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                      <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deletefiles(index)"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row lg:w-full" style="margin-top:30px; margin-left:2px; margin-right:2px; margin-bottom:-12px; padding:3px;">
            <div class="w-full" v-for="(item, index) in fileList" v-bind:key="index" style="margin-top:35px; margin-bottom:-3px;">
              <div class="vx-card text-center" style="margin-top:-20px; margin-bottom:-3px; margin-right:8px; padding:5px;">
                <div class="vx-card__collapsible-content" style="text-align:center;">
                  <div class="vx-row" style="margin:5px; ">
                    <div  style="width: 90%;">
                      <div align="left" style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap; display: block;">{{item}}</div>
                    </div>
                    <div class="vx-row justify-end" style="width:10%; margin-top:-2px; margin-left:5px; margin-bottom:-3px;">
                      <vs-button radius color="danger" type="flat" size="small" icon-pack="feather" icon="icon-x" @click="deleteFileNotice(item)"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="filebox" style="margin-top:30px;">
            <label for="inputFile">첨부 파일</label>
            <input type="file" @change="updateFile" id="inputFile"  name="inputFile" multiple>
          </div>
        </form>
      </component>
    </vs-prompt>
    <vs-prompt
    title="파일 업로드중"
    :buttons-hidden="true"
    :active.sync="uploadPrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <label style="margin-left:10px; margin-top:20px; padding-top:5px; margin-bottom:3px;">파일 업로드중 - 조금만 기다려주세요 :)</label>
        <div class="vx-row lg:w-full" style="margin-top:3px; margin-left:2px; margin-bottom:15px; margin-right:2px; padding:3px;">
          <vs-progress indeterminate color="primary"></vs-progress>
        </div>
      </component>
    </vs-prompt>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import NoticeCard from "@/views/apps/space/dashboard/notice/NoticeCard.vue"
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vSelect from 'vue-select'

export default {
  props: {
    openNoticeId: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      languages_known       :'',
      showThread            : false,
      activePrompt          : false,
      message               : '',
      title                 : '',
      deleteFileName        : [],
      newFileList           : [],
      fileList              : [],
      uploadPrompt          : false,
      fileMaxSize              : 15360000,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.50,
      },
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
      placeholder: '내용을 입력해주세요.'
      },
    }
  },
  watch: {
    isSidebarActive(value) {
      if (!value) {
        this.$emit('closeSidebar')
        setTimeout(() => {
          this.showThread = false
        }, 500)
      }
    },
    currentNotice(){
      if(this.currentNotice && this.currentNotice.file_names){
        this.fileList = this.currentNotice.file_names
      }
    },
    openNoticeId(){
      this.$store.commit('notice/SET_ACTIVE_NOTICE', this.$store.getters['notice/getNotice'](this.openNoticeId))
    }
  },
  computed: {
    currentNotice(){
      return this.$store.state.notice.ActiveNotice
    },
    activeUserLevel() {
      return this.$store.state.space.ActiveDashBoardLevel
    },
    scrollbarTag() { return this.$store.getters.scrollbarTag },
    activeSpaceInfo() {
      return this.$store.state.space.ActiveSpaceInfo
    },
    shareClass() {
      return this.$store.state.space.shareClass
    },
  },
  methods: {
    deletefiles(index){
      this.newFileList.splice(index,1)
    },
    deleteFileNotice(name){
      this.deleteFileName = name
      this.acceptFileDelete()
    },
    acceptFileDelete(){
      this.$store.dispatch('notice/deleteNoticeFile','id='+this.openNoticeId+'&'+'name='+this.deleteFileName).then(()=>{
        if(this.currentNotice && this.currentNotice.file_names){
          this.fileList = this.currentNotice.file_names
        } else {
          this.fileList = []
        }
        this.$vs.notify({
          color: 'danger',
          title: '삭제 완료',
          text: '선택된 파일이 삭제되었습니다.'
        })
      }).catch(() => {
        this.$vs.notify({
          color: 'danger',
          title: '삭제 실패',
          text: '선택된 파일이 없습니다.'
        })
      })
    },
    fileDonwload(item){
      this.$store.dispatch('notice/noticeFileDonwload', {'param':'id='+this.openNoticeId+'&'+'name='+item, 'name': item}).then(() => {
      })
    },
    updateFile(){
      var size = 0
      if(this.currentNotice.file_size){
        size = this.currentNotice.file_size
      }
      for(var index = 0; index <  document.getElementById("inputFile").files.length; index++) {
        var file = document.getElementById("inputFile").files[index]
        size = size + file.size
        if (size > this.$store.state.uploadFileMaxSize) {
          this.$vs.notify({
            color: 'danger',
            title: '에러',
            text: '첨부파일 용량은 15M까지 사용가능합니다'
          })
          break
        }
        if (this.fileList.findIndex(function(item){return item == file.name}) == -1 &&
        this.newFileList.findIndex(function(item){return item.name == file.name}) == -1) {
          this.newFileList.push(file)
        }
      }
    },
    successUpload() {
      this.$vs.notify({ color: 'success', title: 'Upload Success', text: 'Lorem ipsum dolor sit amet, consectetur' })
    },
    editNotice() {
      this.title = this.currentNotice.title
      this.message = this.currentNotice.detail
      this.newFileList = []
      this.activePrompt = true
    },
    clearFields() {
      this.$nextTick(() => {
        this.title = ''
        this.message = ''
        this.newfileList = []
      })
    },
    moveTo(to) {
      this.$emit('closeSidebar')
      this.$emit('moveTo', to)
    },
    deleteNotice() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `공지사항 삭제`,
        text: '해당 공지사항을 삭제하시겠습니까?',
        accept: this.acceptDelete
      })
    },
    acceptDelete() {
      this.$store.dispatch('notice/deleteNotice', this.openNoticeId)
      .then(()=>{
        this.$emit('closeSidebar')
        this.$vs.notify({
          color: 'success',
          title: '삭제 완료',
          text: '선택된 글이 삭제되었습니다.'
        })
      })
    },
    updateNotice() {
      this.uploadPrompt = true
      var shareClass = []
      for (var i in this.languages_known){
        shareClass.push(this.languages_known[i].value)
      }
      this.$store.dispatch('notice/updateNotice', {'id':this.openNoticeId, 'title':this.title, 'detail':this.message,  "files": this.newFileList, "share_class":shareClass}).then(()=>{
        this.uploadPrompt = false
        if(this.currentNotice && this.currentNotice.file_names){
          this.fileList = this.currentNotice.file_names
        }
        this.$vs.notify({
          color: 'success',
          title: '수정 완료'
        })
      }).catch(() => {
        this.uploadPrompt = false
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '관리자에게 문의해 주세요.'
        })
      })
    },
  },
  components: {
    quillEditor,
    VuePerfectScrollbar,
    'noticeCard': NoticeCard,
    vSelect,
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";

.filebox label {
  text-align: center;
  width:100%;
  display: inline-block;
  padding: .5em .75em;
  color: #000000;
  font-size: inherit;
  line-height: normal;
  vertical-align: middle;
  background-color: #E7E7E7;
  cursor: pointer;
  border:  solid #E7E7E7 2px;
  border-radius: .25em;
  -webkit-transition: background-color 0.2s;
  transition: background-color 0.2s;
}

.filebox label:hover {
  background-color: #ffffff;
  border:  solid #E7E7E7 2px;
}

.filebox label:active {
  background-color: #ffffff;
  border:   solid #E7E7E7 2px;
}

.filebox input[type="file"] {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
#email-app{
    .vs-sidebar--background{
        position: absolute;
    }
    .select-all-chexkbox{
        .vs-checkbox{
            margin-right: 0.8rem;
        }
    }
    .email-filter-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 75px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .email-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 100px);

        &:not(.ps) {
          overflow-y: auto;
        }
    }

    .scroll-area-mail-content {
      position: relative;
      margin: auto;
      width: 100%;
      height: calc(100% - 6.3%);

      &:not(.ps) {
        overflow-y: auto;
      }
    }

    .email__mails {
        .mail__opened-mail {
            background-color: #eee;
        }
    }


    .email__mails {

        .email__mail-item {
            transition: all .35s;

            &:not(:first-of-type) {
                .mail__mail-item {
                    border-top: 1px solid #dae1e7;
                }
            }

            .mail__mail-item {
                transition: all 0.2s;


                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0px 3px 10px 0px #ccc;
                    transition: all 0.2s;
                }

                // Star icon color
                .feather-icon {
                    color: #9c9c9c;
                }
            }
        }
    }

    .email-view-sidebar {
        .vs-sidebar{
            background-color: #f8f8f8 !important;
            border-left: 1px solid #dae1e7;
        }

        .email-header{
            box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.04);
            border-bottom: 1px solid #eee;
            z-index: 1;
            position: relative;
        }

        .open-mail-label {
            transition: all .35s;
        }

        .mail__attachment {
          .vs-chip--text {
            margin-left: 0;
            margin-right: 0;
          }
        }
    }
}


// COMPOSE MAIL DIALOG
.con-vs-dialog.email-compose {
    .vs-dialog {
        max-width: 730px;
        // max-height: 95vh;

        .vs-dialog-text {
            padding: 0;

            .scroll-area {
                max-height: 75vh;

                &:not(.ps) {
                  overflow-y: auto;
                }
            }

            .compose-mail-attachment {
              .con-input-upload {
                margin: 0;
              }
            }
        }
    }

    .con-img-upload {

    .con-input-upload {
      height: 2.5rem;
      width: 100%;
    }

        .img-upload {
            // height: 4rem;
            margin: 0;
            margin-bottom: .5rem;
            margin-right: 1.5rem;
        }
    }

    .quill-editor {
        margin-bottom: 1.5rem
    }

    .ql-editor {
        height: 150px;
    }
}

</style>
